module.exports = __webpack_public_path__ + "img/btn-rectangle.7ffa8a1f.svg";